import React from "react";
import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

type SortOrderOptionsType = {
  label: string;
  value: string;
};

type onChangeCallbackType = (event: SelectChangeEvent<string>, child: React.ReactNode) => void;

type SortOrderProps = {
  onChangeCallback: onChangeCallbackType;
  value: string;
  size?: "small" | "medium" | undefined;
  options: SortOrderOptionsType[];
};

const SortOrder = (props: SortOrderProps): JSX.Element => {
  const { onChangeCallback, options, size, value } = props;

  return (
    <FormControl fullWidth size={size}>
      <Select
        color="info"
        id={`sortorder-select`}
        value={value}
        onChange={onChangeCallback}
        sx={{ backgroundColor: "#fff" }}
        IconComponent={KeyboardArrowDownIcon}
      >
        {options.map((item: any, itemIndex: number): JSX.Element | null => {
          return (
            <MenuItem key={`${item.label}-${itemIndex}`} value={item.value}>
              {item.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SortOrder;
